var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreeceFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 32,
  width: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eb0",
  d: "M3.556 27.556h24.888c.624 0 1.21-.162 1.72-.445H1.836c.51.283 1.096.445 1.72.445z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M7.556 17.333H0v2.223h32v-2.223H12.444zM0 24c0 .151.012.299.031.444H31.97c.018-.145.03-.293.03-.444v-1.778H0V24zm12.444-11.556H32v2.223H12.444zm0-4.888v2.222H32V8c0-.151-.012-.299-.031-.444H12.444z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eb0",
  d: "M12.444 9.778H32v2.666H12.444zM0 19.556h32v2.666H0zm1.836 7.555h28.328a3.557 3.557 0 0 0 1.806-2.667H.03a3.554 3.554 0 0 0 1.805 2.667zM0 12.444h4.889v4.89H0zm12.444 2.223v-2.223H7.556v4.89H32v-2.667zm17.72-9.778a3.537 3.537 0 0 0-1.72-.445H3.556A3.557 3.557 0 0 0 0 8v1.778h4.889v-4.89h2.667v4.89h4.888V7.556H31.97a3.554 3.554 0 0 0-1.805-2.667z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M7.556 9.778V4.444H4.889v5.334H0v2.666h4.889v4.89h2.667v-4.89h4.888V9.778z"
})));
export default SvgGreeceFlag;